import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SearchIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.searchIcon}`}
        data-testid={testId}
        fill='none'
        height='16'
        viewBox='0 0 16 16'
        width='16'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.099zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'
            fill='currentColor'
        />
    </svg>
);

export default SearchIcon;
